import produce from "immer";
import { createAsyncAction } from "typesafe-actions";
import { ActionType, createReducer } from "typesafe-actions";
import { ViewServiceRequestData, } from "../../../Types/UnitFeatureTypes";


export interface FetchServiceRequestInfoState {
  request: {
      loading: boolean;
      error: string | null;
      singleServiceRequest: ViewServiceRequestData | null;
      data: ViewServiceRequestData[] | null;
      count: string | null;
  };
}

export enum Types {
  FETCH_SERVICE_REQUESTS_REQUEST = "FETCH_SERVICE_REQUESTS_REQUEST",
  FETCH_SERVICE_REQUESTS_SUCCESS = "FETCH_SERVICE_REQUESTS_SUCCESS",
  FETCH_SERVICE_REQUESTS_FAILURE = "FETCH_SERVICE_REQUESTS_FAILURE",
}

const serviceRequestActions = createAsyncAction(
  Types.FETCH_SERVICE_REQUESTS_REQUEST,
  Types.FETCH_SERVICE_REQUESTS_SUCCESS,
  Types.FETCH_SERVICE_REQUESTS_FAILURE,
)
<
  { id?: string, offset?: number, sortColumn?: string, sortDirection?: string },
  { serviceRequests?: ViewServiceRequestData[], serviceRequest?: ViewServiceRequestData,  count: string },
  { message: string }
>();

export const Actions = { serviceRequestActions };

export const initialState: FetchServiceRequestInfoState = {
  request: {
    loading: false,
    error: null as string | null,
    singleServiceRequest: null,
    data: null,
    count: '0'
  }
};

export type FetchServiceRequestState = typeof initialState;

const fetchServiceRequestRequest = (state = initialState) =>
  produce(state, (draft) => {
    draft.request.loading = true;
    draft.request.error = null;
    draft.request.data = null;

    return draft;
  });

const fetchServiceRequestSuccess = (
  state = initialState,
  { payload }: ActionType<typeof Actions.serviceRequestActions.success>
) =>
  produce(state, (draft) => {
    draft.request.error = null;
    draft.request.data = payload.serviceRequests ?? null;
    draft.request.singleServiceRequest = payload.serviceRequest ?? null;
    draft.request.count = payload.count;
    if (draft.request.data) {
      draft.request.loading = false;
    }

    return draft;
  });

const fetchServiceRequestFailure = (
  state = initialState,
  { payload }: ActionType<typeof Actions.serviceRequestActions.failure>
) =>
  produce(state, (draft) => {
    draft.request.loading = false;
    draft.request.error = payload.message;

    return draft;
  });


export default createReducer<typeof initialState, ActionType<typeof Actions>>(
  initialState
)
  .handleAction(Actions.serviceRequestActions.request, fetchServiceRequestRequest)
  .handleAction(Actions.serviceRequestActions.success, fetchServiceRequestSuccess)
  .handleAction(Actions.serviceRequestActions.failure, fetchServiceRequestFailure);
  